/**
 * Amber color used for incomplete period indicators.
 */
export const INCOMPLETE_PERIOD_COLOR = "#F59E0B";
export const INCOMPLETE_PERIOD_BG = "rgba(245, 158, 11, 0.07)";
export const INCOMPLETE_PERIOD_BORDER = "rgba(245, 158, 11, 0.4)";

/**
 * Build markArea data for the "not filled in yet" background zone: the
 * category-axis span from `fromIndex` through `toIndex` (inclusive). The
 * defaults mark the last bucket only — the incomplete-period case the chat
 * agent stamps. A time axis (ADR-0266) passes the run of buckets that are
 * behind: after the last bucket with data, up to `time_axis.through`.
 * Returns data array for ECharts markArea, or null if not applicable.
 */
export function buildIncompleteZoneMarkArea(
  rowCount: number,
  fromIndex: number = rowCount - 1,
  toIndex: number = fromIndex,
): any[] | null {
  if (rowCount < 2) return null;
  if (fromIndex < 0 || toIndex < fromIndex || fromIndex >= rowCount) return null;

  return [
    [
      {
        xAxis: fromIndex - 0.5,
        itemStyle: { color: INCOMPLETE_PERIOD_BG },
      },
      { xAxis: Math.min(toIndex, rowCount - 1) + 0.5 },
    ],
  ];
}

/**
 * Build markLine data for the zone's left boundary (vertical dashed line).
 *
 * The label is off on the container AND on the data item: ECharts' default
 * markLine label prints the line's value at its end, which for this boundary
 * is the fractional category index (`7.5`) drawn above the grid top, where
 * it is clipped. The item-level switch survives the merge into an existing
 * markLine (the guardrail), whose container label may be on.
 */
export function buildIncompleteZoneMarkLine(
  rowCount: number,
  fromIndex: number = rowCount - 1,
): any {
  if (rowCount < 2) return null;
  if (fromIndex < 0 || fromIndex >= rowCount) return null;

  return {
    silent: true,
    symbol: "none",
    lineStyle: {
      color: INCOMPLETE_PERIOD_BORDER,
      type: "dashed" as const,
      width: 1,
    },
    label: { show: false },
    data: [{ xAxis: fromIndex - 0.5, label: { show: false } }],
  };
}
